import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { Dba } from '@models/peripherals/dba';
import { DbaForm } from '@models/peripherals/dba-form';
import { Router } from '@angular/router';
import { CamelCaseDirective} from './camel-case.directive';
import {ConfirmPopupComponent} from '@shared/modal-popup/confirm-popup/confirm-popup.component';
@Component({
  selector: 'app-dbaarray',
  templateUrl: './dbaarray.component.html',
  styleUrls: ['./dbaarray.component.css']
})
export class DbaarrayComponent implements OnInit {
  @ViewChild(ConfirmPopupComponent) confirmModal: ConfirmPopupComponent;
  public isCollapsed = true;
  private dbaType: string[];
  anothername = 'Doing Business As';
  addanothername = 'ADD DBA';
  selectColor = '#aaaaaa';
  dbaCounter: number;
  @Input()
  public dbaForm: DbaForm[];

  @Input()
  public dbaFormArray: FormArray;

  @Input()
  public parentId: number;

  @Output() deleteDbaEvent: EventEmitter<number> = new EventEmitter();

  static buildDbas() {
    return new FormArray([
      this.buildDba(''),
    ]);
  }

  static buildFormDba(val: DbaForm): any {
    return new FormGroup({
      dba_id: new FormControl(val.dbaID),
      name: new FormControl(val.name),
    });
  }

  static buildDba(val: string): any {
    return new FormGroup({
      dba_id: new FormControl(null),
      name: new FormControl(val),
    });
  }
  constructor(private router: Router) {

  }
  ngOnInit() {

    if (this.router.url.includes('contacts')) {
      this.anothername = 'Also Known As';
      this.addanothername = 'ADD AKA';
    } else {
      this.anothername = 'Doing Business As';
      this.addanothername = 'ADD DBA';
    }
    if (this.dbaForm) {
      this.dbaFormArray.removeAt(0);
      this.dbaForm.forEach(element => {
        this.dbaFormArray.push(DbaarrayComponent.buildFormDba(element));
      });
    }
    this.dbaCounter = this.dbaForm.length;
  }

  addDba() {
    this.dbaFormArray.push(DbaarrayComponent.buildDba(''));
    this.dbaCounter = this.dbaCounter + 1;
    this.isCollapsed = false;
  }

  changetxtRecord() {
    this.selectColor = '#000000';
  }

  deleteDBA(index) {
    let dba_id = this.dbaFormArray.controls[index.map_id].get('dba_id').value;
   
    if (this.parentId) {
      // emit an event
        this.deleteDbaEvent.emit(dba_id);
        this.dbaFormArray.removeAt(index.map_id);
        this.confirmModal.closeModal();
    } else {
      this.dbaFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
    }
    this.dbaCounter = this.dbaCounter - 1;
  }

  openConfirm(i){
    this.confirmModal.showModal(i);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-control/dba-form-control/dbaarray.component.ts